import React, { Suspense } from "react";
import { Flex, Button, Text } from "@chakra-ui/react";
import { ErrorBoundary } from "react-error-boundary";
import { QueryErrorResetBoundary } from "@tanstack/react-query";

import OrderHistoryFinalCopyHeader from "@/features/my-order/features/order-history/features/final-copy/components/OrderHistoryFinalCopyHeader";
import OrderHistoryFinalCopyFilterBar from "@/features/my-order/features/order-history/features/final-copy/components/OrderHistoryFinalCopyFilterBar";
import OrderHistoryFinalCopyTable from "@/features/my-order/features/order-history/features/final-copy/components/OrderHistoryFinalCopyTable";
import CenteredSpinner from "@/shared/components/centered-spinner";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

function TableErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <Flex
      flex={1}
      minHeight={0}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      gap={"12px"}
    >
      <Text>테이블 데이터를 불러오지 못했습니다.</Text>
      <Text color={"#6F6F6C"} fontSize={"14px"}>
        {error.message}
      </Text>
      <Button onClick={resetErrorBoundary}>다시 시도</Button>
    </Flex>
  );
}

function OrderHistoryFinalCopy() {
  const { error: showError } = useAppToasts();

  return (
    <Flex flexDirection={"column"} height={"100%"}>
      <OrderHistoryFinalCopyHeader />
      <OrderHistoryFinalCopyFilterBar />

      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary
            onReset={reset}
            onError={(error) => showError(error)}
            fallbackRender={({ error, resetErrorBoundary }) => (
              <TableErrorFallback
                error={error}
                resetErrorBoundary={resetErrorBoundary}
              />
            )}
          >
            <Suspense fallback={<CenteredSpinner />}>
              <OrderHistoryFinalCopyTable />
            </Suspense>
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </Flex>
  );
}

export default OrderHistoryFinalCopy;
